import React from 'react';

export interface TableShellProps {
  children: React.ReactNode;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
  bodyClassName?: string;
}

const TableShell: React.FC<TableShellProps> = ({
  children,
  title,
  subtitle,
  actions,
  className = '',
  bodyClassName = '',
}) => {
  const hasHeader = title || subtitle || actions;

  return (
    <section className={`overflow-hidden rounded-xl border border-monday-border-light bg-white/95 shadow ${className}`}>
      {hasHeader && (
        <div className="flex items-start justify-between gap-4 border-b border-monday-border-light bg-white/70 px-5 py-4">
          <div className="min-w-0">
            {title && <h3 className="text-sm font-bold tracking-tight text-monday-text">{title}</h3>}
            {subtitle && <p className="mt-0.5 text-xs text-monday-text-muted">{subtitle}</p>}
          </div>
          {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
        </div>
      )}
      <div className={`custom-table-container overflow-x-auto ${bodyClassName}`}>
        {children}
      </div>
    </section>
  );
};

export default TableShell;
